import { render, staticRenderFns } from "./MeuPerfil.vue?vue&type=template&id=356bcb1a&scoped=true"
import script from "./MeuPerfil.vue?vue&type=script&lang=js"
export * from "./MeuPerfil.vue?vue&type=script&lang=js"
import style0 from "./MeuPerfil.vue?vue&type=style&index=0&id=356bcb1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.92.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356bcb1a",
  null
  
)

export default component.exports